// Mobile navigation drawer toggle.
//
// Markup:
//   <header data-controller="nav">
//     <button data-action="nav#toggle">…</button>
//     <nav data-nav-target="drawer" class="hidden md:flex">…</nav>
//     <div data-action="click->nav#close" class="hidden" data-nav-target="overlay"></div>
//   </header>
import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["drawer", "overlay"]
  declare readonly drawerTarget: HTMLElement
  declare readonly hasDrawerTarget: boolean
  declare readonly overlayTarget: HTMLElement
  declare readonly hasOverlayTarget: boolean

  connect(): void {
    document.addEventListener("keydown", this._onKey)
    document.addEventListener("turbo:before-visit", this.close)
  }

  disconnect(): void {
    document.removeEventListener("keydown", this._onKey)
    document.removeEventListener("turbo:before-visit", this.close)
  }

  toggle(): void {
    this._isOpen() ? this.close() : this.open()
  }

  open(): void {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.remove("hidden")
      this.drawerTarget.classList.add("flex")
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }
    document.body.classList.add("overflow-hidden", "md:overflow-auto")
  }

  close = (): void => {
    if (this.hasDrawerTarget) {
      this.drawerTarget.classList.add("hidden")
      this.drawerTarget.classList.remove("flex")
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
    }
    document.body.classList.remove("overflow-hidden", "md:overflow-auto")
  }

  private _isOpen(): boolean {
    return this.hasDrawerTarget && !this.drawerTarget.classList.contains("hidden")
  }

  private _onKey = (e: KeyboardEvent): void => {
    if (e.key === "Escape" && this._isOpen()) this.close()
  }
}
